<template>
    <div>
        <component
            :is="componentName" 
            :width="width" 
            :height="height || width"
            v-bind="$attrs"
        />
    </div>
</template>

<script>
import CardDiners from "../ui/logos/Diners.vue";
import CardDiscover from "../ui/logos/Discover.vue";
import CardAmex from "../ui/logos/Amex.vue";
import CardMastercard from "../ui/logos/Mastercard.vue";
import CardVisa from "../ui/logos/Visa.vue";
import CardMaestro from "../ui/logos/Maestro.vue"; 
import CardVerve from "../ui/logos/Verve.vue"; 

const TYPES = {
    DINERS: "CardDiners",
    DISCOVER: "CardDiscover",
    AMERICAN: "CardAmex",
    MASTERCARD: "CardMastercard",
    MAESTRO: "CardMaestro",
    VISA: "CardVisa",
    VERVE: "CardVerve",
};

export default {
    name: "CreditCard",

    components: {
        CardDiners,
        CardDiscover,
        CardAmex,
        CardMastercard,
        CardVisa,
        CardMaestro,
        CardVerve,
    },

    props: {
        type: {
            default: "VISA",
            type: String,
        },
        width: {
            default: "16px",
            type: String,
        },
        height: {
            default: "16px",
            type: String,
        },
    },

    computed: {
        componentName() {            
            return TYPES[this.type?.toUpperCase()] || null;
        },
    },
};
</script>